import { axios } from '@/api/common'
import { queryOptions } from '@tanstack/react-query'
import { Inv3010GetResultModel, Inv3010GetResultSchema } from './get.schema'

export async function fetchInv3010(id: number): Promise<Inv3010GetResultModel> {
  const response = await axios.get<Inv3010GetResultModel>(
    `/api/warehouse/inv3010/${id}`
  )
  return Inv3010GetResultSchema.parse(response.data)
}

export const getInv3010ByIdOptions = (id: number) =>
  queryOptions({
    queryKey: ['inv3010', id],
    queryFn: () => fetchInv3010(id),
  })
